<template>
 <!-- The new look (Seaded -> Objekt uues kujunduses): the contract as a plate
      with the hooldus band under it, and what happened here lately beside it. -->
 <div v-if="plate && object.id" class="obj-info">
  <div class="obj-info__main">
   <section class="obj-card" :class="isContract ? 'obj-card--plate' : 'obj-card--plain'">
    <div class="obj-card__head obj-card__head--flat">
     <h2 class="obj-cap-title obj-mid">{{ isContract ? 'LEPING' : 'ÜLDINFO' }}</h2>
     <router-link v-if="canEdit('object', object)" :to="editLink" class="obj-link obj-link--caps">MUUDA</router-link>
    </div>
    <div class="obj-fields">
     <div v-for="field in fields" :key="field.k" class="obj-field">
      <span class="obj-field__k">{{ field.k }}</span>
      <router-link v-if="field.to" :to="field.to" class="obj-field__v">{{ field.v }}</router-link>
      <span v-else class="obj-field__v d-flex align-center ga-2" :class="{ 'obj-field__v--none': field.none }">
       <span v-if="field.person" class="obj-ini" :style="dot(field.person.color)">{{ initials(field.person.name) }}</span>{{ field.v }}
      </span>
     </div>
    </div>
    <!-- The band: when it was last done and when it is due; amber while a
         deadline has passed with no hooldus against it. -->
    <router-link v-if="isContract && service" :to="tab('maintenance')" class="obj-band" :class="{ 'obj-band--late': late.length }">
     <span>
      <span class="obj-cap">{{ late.length ? 'HOOLDUS HILJAKS' : 'HOOLDUS' }}</span>
      <b>{{ lateText }}</b>
     </span>
     <span>
      <span class="obj-cap">VIIMANE HOOLDUS</span>
      <em>{{ service.last ? day(service.last.date) + (service.last.who ? ' · ' + service.last.who.name : '') : '—' }}</em>
     </span>
     <span>
      <span class="obj-cap">JÄRGMINE TÄHTAEG</span>
      <em>{{ service.next ? monthYear(service.next) : '—' }}</em>
     </span>
    </router-link>
    <div v-if="!isContract" class="obj-hint">
     <span>Lepinguta objekt: hoolduse tähtaegu sellel ei ole.</span>
     <router-link v-if="canEdit('object', object)" :to="editLink" class="obj-btn obj-btn--outline obj-btn--sm obj-btn--muted">+ Lisa leping</router-link>
    </div>
   </section>

   <section class="obj-card">
    <div class="obj-card__head">
     <h2>Seadmed</h2>
     <router-link :to="tab('devices')" class="obj-link obj-link--caps">HALDA SEADMEID</router-link>
    </div>
    <div class="obj-row">
     <span v-if="deviceSummary" class="obj-row__text"><b>{{ deviceSummary }}</b></span>
     <span v-else class="obj-row__text">Seadmeid pole lisatud.<template v-if="notesHint"> Märkustes on kirjas: <b>{{ notesHint }}</b></template></span>
     <router-link v-if="!deviceSummary" :to="tab('devices')" class="obj-btn obj-btn--outline obj-btn--sm">Lisa seade</router-link>
    </div>
   </section>

   <section class="obj-card">
    <div class="obj-field obj-field--flush">
     <span class="obj-field__k">MÄRKUSED</span>
     <span class="obj-field__text" :class="{ 'obj-field__v--none': !object.notes }">{{ object.notes || '—' }}</span>
    </div>
    <div class="obj-field">
     <span class="obj-field__k">KOMMENTAARID</span>
     <span class="obj-field__text" :class="{ 'obj-field__v--none': !object.comments }">{{ object.comments || '—' }}</span>
    </div>
   </section>

   <div class="obj-meta">
    Lisas <b>{{ object.adder && object.adder.fullName || '—' }}</b> {{ object.createdDate ? day(object.createdDate) : '' }}
    <template v-if="object.editor"> · Muutis <b>{{ object.editor.fullName }}</b> {{ object.updatedDate ? day(object.updatedDate) : '' }}</template>
   </div>
  </div>

  <!-- Viimati siin: notes, work orders and acts, newest first, a line each. -->
  <section class="obj-card">
   <div class="obj-card__head"><h2>Viimati siin</h2><span class="obj-cap">UUEMAD ENNE</span></div>
   <div v-if="overview && !recent.length" class="obj-empty">Siin pole veel midagi juhtunud.</div>
   <template v-for="row in recent" :key="row.key">
    <a v-if="row.href" :href="row.href" class="obj-trow">
     <span class="obj-trow__when"><b>{{ row.date }}</b><span class="obj-kind" :class="'obj-kind--' + row.kind">{{ row.label }}</span></span>
     <span class="obj-ini" :style="dot(row.color)">{{ row.ini }}</span>
     <span class="obj-trow__body"><span class="obj-trow__who">{{ row.who }}</span><span class="obj-trow__text">{{ row.text }}</span></span>
    </a>
    <router-link v-else :to="row.to" class="obj-trow">
     <span class="obj-trow__when"><b>{{ row.date }}</b><span class="obj-kind" :class="'obj-kind--' + row.kind">{{ row.label }}</span></span>
     <span class="obj-ini" :style="dot(row.color)">{{ row.ini }}</span>
     <span class="obj-trow__body"><span class="obj-trow__who">{{ row.who }}</span><span class="obj-trow__text">{{ row.text }}</span></span>
    </router-link>
   </template>
   <div class="obj-foot">
    <router-link :to="tab('notes')" class="obj-link">Kõik märkused{{ counts.notes != null ? ' (' + counts.notes + ')' : '' }}</router-link>
    <router-link :to="tab('calendar')" class="obj-link">Kõik töökäsud{{ counts.events != null ? ' (' + counts.events + ')' : '' }}</router-link>
   </div>
  </section>
 </div>
 <v-container v-else-if="object.id" fluid class="pa-0">
    <v-row>
      <v-col cols="12" md="6" class="pt-0">
        <v-card variant="flat" border>
          <v-list>
            <v-list-item>
              <v-list-item-subtitle>Aadress</v-list-item-subtitle>
              <v-list-item-title>{{$address(object.fullAddress)}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Postiindeks</v-list-item-subtitle>
              <v-list-item-title>{{object.postcode || '-'}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Klient</v-list-item-subtitle>
              <v-list-item-title>
                <client-link :client="object.client" />
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="managerOn && isContract">
              <v-list-item-subtitle>Haldusfirma</v-list-item-subtitle>
              <v-list-item-title>
                <client-link v-if="object.manager" :client="object.manager" />
                <template v-else>-</template>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="managerOn && isContract && object.manager">
              <v-list-item-subtitle>Aktid saadetakse · Koondarve maksja</v-list-item-subtitle>
              <v-list-item-title>{{ ['Klient', 'Haldusfirma', 'Mõlemad'][object.aktRecipients] || 'Klient' }} · {{ ['Klient', 'Haldusfirma'][object.billTo] || 'Klient' }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Lepingu number</v-list-item-subtitle>
              <v-list-item-title>{{object.contract || '-'}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Lepingu hind</v-list-item-subtitle>
              <v-list-item-title>{{parseFloat(object.contractPrice || 0).toFixed(2)}} €</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Hoolduse intervall</v-list-item-subtitle>
              <v-list-item-title>{{contractIntervalOptionById(object.contractInterval).text}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Reageerimise aeg</v-list-item-subtitle>
              <v-list-item-title>{{reactionTimeOptionById(object.reactionTime).text}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Seotud tehnik</v-list-item-subtitle>
              <v-list-item-title>{{object.technic && object.technic.fullName || '-'}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Võti</v-list-item-subtitle>
              <v-list-item-title>{{object.key ? 'Jah' : 'Ei'}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Aktiivne</v-list-item-subtitle>
              <v-list-item-title>{{object.active ? 'Jah' : 'Ei'}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Probleemne</v-list-item-subtitle>
              <v-list-item-title>{{object.problematic ? 'Jah' : 'Ei'}}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="object.problematic && object.problematicNote">
              <v-list-item-subtitle>Probleemi põhjus</v-list-item-subtitle>
              <div class="text-body-1" style="white-space: pre-line">{{object.problematicNote}}</div>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Kommentaarid</v-list-item-subtitle>
              <v-list-item-title>{{object.comments || '-'}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Märkused</v-list-item-subtitle>
              <v-list-item-title style="white-space: normal; word-break: break-word;">{{object.notes || '-'}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="pt-0 pb-0">
        <v-card variant="flat" border>
          <v-list>
            <v-list-item>
              <v-list-item-subtitle>Lisas</v-list-item-subtitle>
              <v-list-item-title>{{object.adder && object.adder.fullName}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Lisatud</v-list-item-subtitle>
              <v-list-item-title>{{object.createdDate || '-'}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Muutis</v-list-item-subtitle>
              <v-list-item-title>{{object.editor && object.editor.fullName}}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-subtitle>Muudetud</v-list-item-subtitle>
              <v-list-item-title>{{object.updatedDate || '-'}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <!-- What is installed here, in one line. The list itself — adding,
             editing, archiving — is the Seadmed tab's job; an address with
             several devices was never going to fit at the bottom of Info. -->
        <v-card variant="flat" border>
          <!-- d-flex: Vuetify 2's card title was a flex row, which is what the
               spacer pushes the button across. -->
          <v-card-title class="text-subtitle-1 py-2 d-flex align-center">
            Seadmed
            <v-spacer />
            <v-btn color="primary" :to="{ name: 'object/view/devices', params: { objectId: object.id }}" size="small" variant="text">
              Halda seadmeid
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text class="py-3">
            <span v-if="deviceSummary">{{deviceSummary}}</span>
            <span v-else class="text-grey">Seadmeid pole lisatud</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
 </v-container>
</template>

<script>
import dayjs from 'dayjs'
import { mapState } from 'vuex'
import helpersMixin from '@/plugins/helpersMixin'
import { deviceSummary } from '@/plugins/devices'
import { initials } from '@/components/frame/frameLinks'

const MONTHS = ['jaanuar', 'veebruar', 'märts', 'aprill', 'mai', 'juuni', 'juuli',
  'august', 'september', 'oktoober', 'november', 'detsember']
const KINDS = { service: 'Hooldus', note: 'Märkus', event: 'Töökäsk', akt: 'Akt' }

export default {
  mixins: [ helpersMixin ],
  props: {
    object: {
      required: true
    },
    // The new look, and what object/View.vue read for it.
    plate: {
      type: Boolean,
      default: false
    },
    overview: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState(['features']),
    // Haldur (Seaded): the contract object's managing firm, beside the Klient.
    managerOn () {
      return !!(this.features && this.features.manager)
    },
    // The object payload carries what is installed now — archived devices are
    // filtered out server-side — so this needs no request of its own.
    deviceSummary () {
      return deviceSummary(this.object.devices)
    },
    isContract () {
      return this.object.type === this.objectTypes.CONTRACT
    },
    editLink () {
      return { name: 'object/edit', params: { objectId: this.object.id } }
    },
    counts () {
      return (this.overview && this.overview.counts) || {}
    },
    service () {
      return this.overview && this.overview.service
    },
    late () {
      return (this.service && this.service.overdue) || []
    },
    // "Juuni ja september 2026 tegemata"; more than two by their number.
    lateText () {
      const late = this.late
      if (!late.length) return this.service && this.service.next ? 'Graafikus' : 'Tähtaegu pole'
      if (late.length > 2) return late.length + ' tähtaega tegemata, vanim ' + this.monthYear(late[0])
      const names = late.map(date => MONTHS[dayjs(date).month()])
      const years = [...new Set(late.map(date => dayjs(date).year()))]
      const text = years.length === 1
        ? names.join(' ja ') + ' ' + years[0]
        : late.map(date => this.monthYear(date)).join(' ja ')
      return text.charAt(0).toUpperCase() + text.slice(1) + ' tegemata'
    },
    fields () {
      const o = this.object
      const client = o.client && o.client.id
        ? { k: 'KLIENT', v: o.client.fullName || o.client.title || '—', to: { name: 'client/view/info', params: { clientId: o.client.id } } }
        : { k: 'KLIENT', v: '—', none: true }
      const yesNo = value => value ? 'Jah' : 'Ei'
      const technic = o.technic && o.technic.fullName
      if (!this.isContract) {
        return [
          client,
          { k: 'TELEFON', v: (o.client && o.client.phone) || '—', none: !(o.client && o.client.phone) },
          { k: 'E-POST', v: (o.client && o.client.email) || '—', none: !(o.client && o.client.email) },
          { k: 'POSTIINDEKS', v: o.postcode || '—', none: !o.postcode },
          { k: 'VÕTI', v: yesNo(o.key) },
          { k: 'PROBLEEMNE', v: yesNo(o.problematic) }
        ]
      }
      const manager = o.manager && o.manager.id
        ? { k: 'HALDUSFIRMA', v: o.manager.fullName || o.manager.title || '—', to: { name: 'client/view/info', params: { clientId: o.manager.id } } }
        : { k: 'HALDUSFIRMA', v: '—', none: true }
      return [
        client,
        ...(this.managerOn ? [manager] : []),
        ...(this.managerOn && o.manager && o.manager.id ? [
          { k: 'AKTID SAADETAKSE', v: ['Klient', 'Haldusfirma', 'Mõlemad'][o.aktRecipients] || 'Klient' },
          { k: 'KOONDARVE MAKSJA', v: ['Klient', 'Haldusfirma'][o.billTo] || 'Klient' }
        ] : []),
        { k: 'LEPINGU NUMBER', v: o.contract || '—', none: !o.contract },
        { k: 'LEPINGU HIND', v: parseFloat(o.contractPrice || 0).toFixed(2).replace('.', ',') + ' €' },
        { k: 'HOOLDUSE INTERVALL', v: this.contractIntervalOptionById(o.contractInterval).text },
        { k: 'REAGEERIMISE AEG', v: this.reactionTimeOptionById(o.reactionTime).text },
        { k: 'SEOTUD TEHNIK', v: technic || '—', none: !technic, person: technic ? { name: technic, color: o.technic.color } : null },
        { k: 'POSTIINDEKS', v: o.postcode || '—', none: !o.postcode },
        { k: 'VÕTI', v: yesNo(o.key) },
        { k: 'PROBLEEMNE', v: yesNo(o.problematic) }
      ]
    },
    // With no devices entered, what the office wrote about the equipment.
    notesHint () {
      const text = (this.object.notes || '').replace(/\s+/g, ' ').trim()
      return text.length > 80 ? text.slice(0, 79) + '…' : text
    },
    recent () {
      return ((this.overview && this.overview.recent) || []).map(row => {
        const who = row.who ? row.who.name : '—'
        let text = row.text || ''
        if (row.kind === 'event') {
          const kind = this.calendarCategoryById(row.category).text
          text = kind + ' · ' + dayjs(row.date).format('HH:mm') + '–' + dayjs(row.endDate).format('HH:mm') + (text ? ' · ' + text : '')
        }
        if (row.kind === 'akt') {
          text = 'Akt nr ' + row.id + ' · ' + row.state + ' · ' + Number(row.sumTotal || 0).toFixed(2).replace('.', ',') + ' €'
        }
        return {
          key: row.kind + row.id,
          kind: row.kind === 'akt' ? 'akt' : row.kind,
          label: KINDS[row.kind],
          date: this.day(row.date),
          who,
          ini: row.who ? initials(row.who.name) : '–',
          color: row.who && row.who.color,
          text: text || '—',
          // The act lives in its own app, so it leaves by href.
          href: row.kind === 'akt' ? '/akt/' + row.id : null,
          to: this.tab(row.kind === 'event' ? 'calendar' : row.kind === 'akt' ? 'akts' : 'notes')
        }
      })
    }
  },
  methods: {
    initials,
    tab (name) {
      return { name: 'object/view/' + name, params: { objectId: this.object.id } }
    },
    day (date) {
      return date ? dayjs(date).format('DD.MM.YYYY') : '—'
    },
    monthYear (date) {
      const d = dayjs(date)
      return MONTHS[d.month()].charAt(0).toUpperCase() + MONTHS[d.month()].slice(1) + ' ' + d.year()
    },
    // A technician's colour behind white initials; a pale one gets dark ink.
    dot (color) {
      if (!color) return null
      const hex = color.replace('#', '')
      const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex
      const [r, g, b] = [0, 2, 4].map(i => parseInt(full.slice(i, i + 2), 16))
      const light = (0.299 * r + 0.587 * g + 0.114 * b) > 150
      return { background: color, color: light ? '#16322A' : '#fff' }
    }
  }
}
</script>
